export default __webpack_public_path__ + "static/media/atindra.fa6b7b5a.jpg";